import { Page } from "modules/Page";

export class SubcategoryListingsPage extends Page<typeof SubcategoryListingsPage> {
    public static readonly className = "js-subcategory-listings-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.initCategoriesTabs();
    }

    public initCategoriesTabs() {
        const categories = this.rootElement.querySelectorAll(".tab-categories > div");
        const tabs = this.rootElement.querySelector(".tab-list");

        // Create list items for each block
        categories.forEach((category, index) => {
            category.setAttribute("data-item", index.toString());

            const listItem = document.createElement("li");
            const categoryId = category.getAttribute("id");

            listItem.setAttribute("data-item", index.toString());

            if (categoryId !== null) {
                listItem.innerHTML = categoryId.toString();
            }

            if (listItem && tabs) {
                tabs.appendChild(listItem);
            }
        });

        const tabButtons = this.rootElement.querySelectorAll(".tab-list li");

        // Initialize first tab as active
        tabButtons[0].classList.add('active');
        categories[0].classList.add('active');

        // Handle tab click events
        tabButtons.forEach((tab) => {
            tab.addEventListener("click", () => {
                const isActive = tab.classList.contains("active");
                const tabId = tab.getAttribute("data-item");
                const tabContent = this.rootElement.querySelectorAll(`div[data-item="${tabId}"]`);

                if (isActive) {
                    return;
                }

                // Close all tabs
                tabButtons.forEach((otherTab) => otherTab.classList.remove("active"));
                categories.forEach((category) => category.classList.remove('active'));

                // Open clicked tab if not already active
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                }
            });
        });
    }

}
